/* eslint-disable */
import React, { createContext, useState } from 'react';
import { BracketData, CostBasedPricingFormData, CostBasedPricingSearchData, CostPricingRuleDetail, DropDownData, ErrorMessage, Loader, SubDeptData, UserInfo } from '../../shared/interface/CostBasedPricingInterface';
import { CostBasedPricingHeading } from '../../../constants/constants';
import { getCostBasedPricingDetails } from '../../../api/user';
export const CostBasedPricingContext = createContext<any>('');

export function CostBasedPricingProvider(props: any) {
    const [costBasedPricingSearchData, setCostBasedPricingSearchData] = useState<CostBasedPricingSearchData>({
        zone: '2000',
        department: '',
        subdepartment: '',
        bracket: ''
    })
    const zoneOptions = [{
        label: "Select",
        value: "",
    }, {
        label: "2000",
        value: "2000",
    }];
    const [deptOptions, setDeptOptions] = useState<DropDownData[]>([{
        label: "Select",
        value: "",
    }]);
    const [subDeptOptions, setsubDeptOptions] = useState<SubDeptData[]>([{
        label: "Select",
        value: "",
        departmentnumber: ''
    }]);
    const [bracketOptions, setbracketOptions] = useState<BracketData[]>([{
        label: "Select",
        value: "",
        subdepartmentnumber: ''
    }]);
    const [deptFormOptions, setDeptFormOptions] = useState<DropDownData[]>([{
        label: "Select",
        value: "",
    }]);
    const [subDeptFormOptions, setsubDeptFormOptions] = useState<SubDeptData[]>([{
        label: "Select",
        value: "",
        departmentnumber: ''
    }]);
    const [bracketFormOptions, setbracketFormOptions] = useState<BracketData[]>([{
        label: "Select",
        value: "",
        subdepartmentnumber: ''
    }]);
    const [loader, setLoader] = useState<Loader>({
        dropdownLoader: false,
        contentLoader: false,
        mainPage: false
    })
    const [dropDownData, setDropDownData] = useState({})
    const [pageDisplay, setPageDisplay] = useState<Number>(0);
    const [displayGrid, setDisplayGrid] = useState<boolean>(false);
    const [displayForm, setDisplayForm] = useState<boolean>(false);
    const [formProps, setFormProps] = useState(undefined);
    const [costBasedPricingGridContent, setCostBasedPricingGridContent] = useState<CostPricingRuleDetail[]>([]);
    const [gridHeaders, setGridHeaders] = useState(CostBasedPricingHeading);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [pageNumber, setPageNumber] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [pricingQueueId, setPricingQueueId] = useState('');
    const costBasedFormData = {
        zone: '2000',
        department: '',
        subdepartment: '',
        bracket: '',
        startDate: '',
        endDate: '2099-12-31',
        publishPriceForExisitingRMS: '',
        publishPriceWhenCostChanges: '',
        schedule: '',
        minRatePct: '',
        maxRatePct: '',
        minRateNew: '',
        maxRateNew: '',
        minRateUsed: '',
        maxRateUsed: '',
        turns: '',
        termMax: '',
        initialAmount: '',
        growth: '',
        lineShiftLr: '',
        lineShiftUd: '',
        usedRateAdjustment: ''
    }
    const [costBasedPricingFormData, setCostBasedPricingFormData] = useState<CostBasedPricingFormData>(costBasedFormData)
    const [errorMessage, setErrorMessage] = useState<ErrorMessage>({
        startDate: '',
        endDate: '',
        minRatePct: '',
        maxRatePct: '',
        minRateNew: '',
        maxRateNew: '',
        minRateUsed: '',
        maxRateUsed: '',
        termMax: '',
    })
    const [handlePopup, setHandlePopup] = useState({
        isOpen: false,
        Content: '',
        index: 0,
        type: ''
    })
    const [userInfo, setUserInfo] = useState<UserInfo>({
        emailId: '',
        employeeId: '',
        userName: '',
        hasApproveAccess: false,
        hasEditAccess: false
    })
    const searchCostBasedPricingDetails = async (offset: string = '1') => {
        try {
            setDisplayGrid(true);
            setLoader({ ...loader, contentLoader: true });
            const request = {
                zoneNumber: [costBasedPricingSearchData.zone],
                departmentNumber: costBasedPricingSearchData.department,
                subdepartmentNumber: costBasedPricingSearchData.subdepartment || null,
                bracketNumber: costBasedPricingSearchData.bracket || null,
                offset: offset,
                limit: '25',
            }
            setTotalRowCount(0);
            console.log(request, 'request in search fn')
            const searchResponse: any = await getCostBasedPricingDetails(request);
            setLoader({ ...loader, contentLoader: false });
            if (searchResponse.status == 200 && searchResponse.data) {
                setPageDisplay(200)
                setTotalRowCount(searchResponse.data.totalRecordsCount)
                setCostBasedPricingGridContent(searchResponse.data.costPricingRuleDetails)
                setPageCount(Math.ceil(searchResponse.data.totalRecordsCount / 25));
            }
            else if ((searchResponse.status == 200 && !searchResponse.data) || searchResponse.status == 204) {
                setPageDisplay(204)
            }
            else if (searchResponse.status == 400) {
                setPageDisplay(400)
            }
            else {
                setPageDisplay(500)
            }

        }
        catch (e) {
            setPageDisplay(500)
        }
    }

    return (
        <div>
            <CostBasedPricingContext.Provider
                value={{
                    costBasedPricingSearchData, setCostBasedPricingSearchData,
                    deptOptions, setDeptOptions, subDeptOptions, setsubDeptOptions,
                    bracketOptions, setbracketOptions, zoneOptions, loader, setLoader,
                    dropDownData, setDropDownData, pageDisplay, setPageDisplay,
                    costBasedPricingGridContent, setCostBasedPricingGridContent,
                    displayGrid, setDisplayGrid, displayForm, setDisplayForm,
                    costBasedPricingFormData, setCostBasedPricingFormData,
                    formProps, setFormProps, gridHeaders, setGridHeaders,
                    totalRowCount, setTotalRowCount, pageNumber, setPageNumber,
                    pageCount, setPageCount, searchCostBasedPricingDetails,
                    errorMessage, setErrorMessage, pricingQueueId, setPricingQueueId,
                    costBasedFormData, handlePopup, setHandlePopup, userInfo, setUserInfo,
                    deptFormOptions, setDeptFormOptions, subDeptFormOptions, setsubDeptFormOptions,
                    bracketFormOptions, setbracketFormOptions
                }}
            >
                {props.children}
            </CostBasedPricingContext.Provider>
        </div>
    );
}
